module.exports = __webpack_public_path__ + "img/1487716598-screen-shot-2017-02-21-at-53623-pm.eacecc25.png";